export default __webpack_public_path__ + "static/media/ranking-exp-deduction-step3.bdf22bbf.png";